var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelButtonClearSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cancel_14px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 14,
    height: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M124.044,123.228l2.283-2.283a.577.577,0,1,0-.816-.817l-2.283,2.283-2.283-2.283a.578.578,0,1,0-.817.817l2.283,2.283-2.283,2.283a.578.578,0,0,0,.817.817l2.283-2.283,2.283,2.283a.578.578,0,0,0,.817-.817Z",
    transform: "translate(-116.228 -116.228)",
    fill: "#969fb1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButtonClearSmallIcon);
export default __webpack_public_path__ + "static/media/cancel-button-clear-small-icon.1fae7aa712b0502cda4bc1f5a47e5870.svg";
export { ForwardRef as ReactComponent };